export enum ElasticsearchOperation {
  INDEX = 'index',
  UPDATE = 'update',
  DELETE = 'delete'
}
